import { render } from "./addNews.vue?vue&type=template&id=7108834e&scoped=true"
import script from "./addNews.vue?vue&type=script&lang=js"
export * from "./addNews.vue?vue&type=script&lang=js"

import "./addNews.vue?vue&type=style&index=0&id=7108834e&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\jll-web-xintan\\official-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7108834e"]])

export default __exports__